import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import {
  AuthenticatedTemplate,
  MsalAuthenticationTemplate,
  MsalProvider,
  UnauthenticatedTemplate,
} from '@azure/msal-react';
import { ThemeProvider } from 'osep-react-antd';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import AppLayout from './components/AppLayout';
import config from './config';
import AddInfraAsCodePage from './pages/AddInfraAsCodePage';
import AddProjectsPage from './pages/AddProjectPage';
import AddProjectPresets from './pages/AddProjectPresets';
import ConfigureProjectPage from './pages/ConfigureProjectPage';
import InfraAsServicePage from './pages/InfraAsServicePage';
import MainPage from './pages/MainPage';
import ProjectsPage from './pages/ProjectsPage';
import ConfigureInfrastructurePage from './pages/ConfigureInfraAsCodePage';

const publicClientApplication = new PublicClientApplication({
  auth: {
    clientId: config.msalClientId,
    authority: config.msalAuthority,
  },
});

const authRequest = {
  scopes: [config.msalClientId + '/.default', 'offline_access'],
  authority: config.msalAuthority,
  redirectUri: window.location.origin,
};

function App() {
  return (
    <ThemeProvider>
      <MsalProvider instance={publicClientApplication}>
        <AuthenticatedTemplate>
          <BrowserRouter>
            <AppLayout>
              <Routes>
                <Route path="/" element={<MainPage />} />
                <Route path="/projects" element={<ProjectsPage />} />
                <Route path="/projects/add" element={<AddProjectsPage />} />
                <Route
                  path="/projects/:groupName/:projectName"
                  element={<ConfigureProjectPage />}
                />
                <Route path="/ias" element={<InfraAsServicePage />} />
                <Route path="/ias/add" element={<AddInfraAsCodePage />} />
                <Route
                  path="/ias/add/:projectId/:templateName"
                  element={<ConfigureInfrastructurePage />}
                />
                <Route path="presets" element={<AddProjectPresets />} />
              </Routes>
            </AppLayout>
          </BrowserRouter>
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <MsalAuthenticationTemplate
            authenticationRequest={authRequest}
            interactionType={InteractionType.Redirect}
          />
        </UnauthenticatedTemplate>
      </MsalProvider>
    </ThemeProvider>
  );
}

export default App;
